import { RateItem } from ".";

/**
 * Represents the state of rate items for a deal item, including tracking of changes and removals.
 */
export class DealItemStateRates {

  /**
   * The unique identifier of the deal item.
   */
  public dealItemId?: string | null = null;

  /**
   * A set of rate item IDs that have been changed.
   */
  public idsChanged = new Set<string>();

  /**
   * A set of rate item IDs that have been removed.
   */
  public idsRemoved = new Set<string>();

  /**
   * The client identifier associated with this state.
   */
  public clientId: number = 1;

  /**
   * The list of rate items associated with the deal item.
   */
  public dataItems: RateItem[] = [];

  /**
   * The time segment associated with the rate items.
   */
  public timeSegment: number = 1;
  

  /**
   * reset the state changes, keeping the data items
   */
  public reset(): void {

    this.idsChanged.clear();
    this.idsRemoved.clear();
    this.clientId = 1;

  }

  /**
   * Returns true if there are changes in the state that need to be saved
   * @returns
   */
  public hasChanges(): boolean {

    const hasChanges = this.dataItems.some(x =>
      // Edit row check : if the row is in edit mode
      x.isEditItem === true
      // New row check : if the id is null or undefined or empty i.e. a new row and a value exists in the first index lookup
      || (
        x.idxVal1 &&
        (x.id === null || x.id === undefined || x.id.length < 1)
      )
      //// Check if the row still requires calculation
      //|| (x.idxVal1 && !x.customerPrice)
    );

    if (hasChanges === true) {
      return true;
    }

    return this.idsChanged.size > 0 || this.idsRemoved.size > 0;
  }

}
